/** Адрес service worker кабинета. Один на origin — см. комментарий в public/sw.js. */
export const SERVICE_WORKER_URL = "/sw.js";

/** Как часто спрашиваем у браузера, не вышла ли новая версия. */
export const UPDATE_CHECK_INTERVAL_MS = 30 * 60 * 1000;
